import React from 'react';
import '../App.css';

export const About = () => {
    const FAQS = [
    {
        id: "purpose",
        question: "What is the purpose of this website?",
        answer: "This website is meant to be a community-driven space for Karuta players to show off their collections. Discord is great for playing the game, trading, and dropping cards, but browsing unique and cool cards is difficult. This site makes it easier to discover unique morphs and sketches, react to and favorite uploads, and share your creations with a wider audience. In the future, I hope to expand this with features like following users and a feed to see what your friends are uploading as well as different upload types."
    },
    {
        id: "images",
        question: "What images can I upload?",
        answer: "Images must come from actions on karuta, like kv, using a frame or swap orb. Screenshots or images edited outside of karuta are not allowed."
    },
    {
        id: "space",
        question: "Why am I limited to 5 sketch uploads and 5 morph uploads?",
        answer: "This project is currently self-funded while I finish my final semester of university. All uploaded images are stored and served at my own expense, so limits are in place to keep costs manageable. I hope to explore monetization options in the future so these limits can be increased or removed."
    },
    {
        id: "disabled-pages",
        question: "Why are some pages unavailable?",
        answer: "Some pages may be temporarily disabled while features are being worked on or improved. When this happens, the page will be marked as under construction."
    },
    {
        id: "morphs",
        question: "What morphs are safe from deletion?",
        answer: "As mentioned during upload, not all morphs are guaranteed to stay permanently. Due to storage constraints, morphs that are not particularly rare, unique, or visually interesting may be removed. This helps keep the database focused on standout morphs and prevents excessive storage costs for common morph."
    },
    {
        id: "frames",
        question: "What is the Frames page?",
        answer: "The Frames page was the original focus of the project. It started as a Discord bot that tracked Karuta market values and eventually evolved into this website. While the site has shifted toward showcasing morphs and sketches, I may revisit market-related features in the future."
    },
    {
        id: "uploads",
        question: "Will we be able to upload more in the future?",
        answer: "Development may be slower for the next few months as I finish university, but if there is strong interest in the site, I will actively look for ways to expand storage and increase upload limits. Community feedback will play a big role in shaping what comes next."
    },
    {
        id: "features",
        question: "What features do you plan to add?",
        answer: "Planned ideas include support for idols, albums, card decorations, and more community-focused features. I’m always open to suggestions, though larger additions will take time. For now, the focus will remain on Karuta-related content."
    },
    {
        id: "disclaimer",
        question: "Disclaimer",
        answer: "This is a work in progress, and bugs are to be expected. Please report any issues you encounter so they can be addressed, send them to toottootx on discord."
    }
];


    return (
        <div className="morphpagecontent">
            <main id="infiniteScrollContainer">
                <div className="container mt-5">
                    <div
                        className="card p-4 shadow-sm border-0"
                        style={{ backgroundColor: "#2b2d31", color: "#ffffff" }}
                    >
                        <h1 className="text-center mb-4 border-bottom">FAQ</h1>

                        <div className="accordion" id="faqAccordion">
                            {FAQS.map((faq) => (
                                <div className="accordion-item bg-transparent border-0" key={faq.id}>
                                    <h2 className="accordion-header">
                                        <button
                                            className="accordion-button collapsed"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target={`#faq-${faq.id}`}
                                            style={{ backgroundColor: "#2b2d31", color: "#ffffff" }}
                                        >
                                            {faq.question}
                                        </button>
                                    </h2>

                                    <div
                                        id={`faq-${faq.id}`}
                                        className="accordion-collapse collapse"
                                        data-bs-parent="#faqAccordion"
                                    >
                                        <div className="accordion-body">
                                            {faq.answer}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>
                </div>
            </main>
        </div>
    );
};
 
